import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import NewTable from '../../components/Table/NewTable';
import { activity } from '../../schema/activity';
import { group } from '../../schema/group';
import { activityItem } from '../../schema/activity-item';
import { activityExtra } from '../../schema/activityExtra';
import { driver } from '../../schema/driver';
import { enumItems } from '../../schema/enumItems';
import { enumItemsWithSalesPartner } from '../../schema/enumItemsWithSalesPartner';
import { statuses } from '../../schema/statuses';

import { guideCost } from '../../schema/guideCost';
import { guideWage } from '../../schema/guideWage';
import { accommodation } from '../../schema/accommodation';
import { rate } from '../../schema/rate';
import { contact } from '../../schema/contact';
import { bankAccount } from '../../schema/bankAccount';
import { address } from '../../schema/address';
import { color } from '../../schema/color';
import { serviceProvider } from '../../schema/serviceProvider';
import { accommodationType } from '../../schema/accommodationType';
import { accommodationPrice } from '../../schema/accommodationPrice';
import { activityPrice } from '../../schema/activityPrice';
import { salesPartner } from '../../schema/salesPartner';
import { roomType } from '../../schema/roomType';
import { languageSkills } from '../../schema/languageSkills';
import { activityReservationCost } from '../../schema/activityReservationCost';
import { guide } from '../../schema/guide';
import { restaurant } from '../../schema/restaurant';
import { singleStripperReservation } from '../../schema/singleStripperReservation';
import { activityReservation } from '../../schema/activityReservation';
import { roomReservation } from '../../schema/roomReservation';
import { accommodationReservation } from '../../schema/accommodationReservation';
import { enumItemsWithColor } from '../../schema/enumItemsWithColor';
import { service } from '../../schema/service';
import { comment } from '../../schema/comment';
import { servicePrice } from '../../schema/servicePrice';
import { partnerName } from '../../schema/partnerName';
import { serviceReservation } from '../../schema/serviceReservation';
import { competitor } from '../../schema/competitor';
import { competitorPrice } from '../../schema/competitorPrice';
import { promotions } from '../../schema/promotions';
import { SlidingPane } from '../../components/Page/SlidingPane';

import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import styles from '../../components/Document/styles.module.css';
import { SlidingPaneAddNew } from '../../components/Page/SlidingPaneAddNew';
import { debounce } from 'lodash';
import { corporate } from '../../schema/corporate';
import { corporatePayment } from '../../schema/corporatePayment';
import { SocketProvider } from '../../contexts/SocketContext';
import {accommodationCategory} from "../../schema/accommodationCategory";

const PATH_TO_SCHEMA: any = {
  activities: activity,
  'activity-items': activityItem,
  'activity-prices': activityPrice,
  'activity-statuses': statuses.activityStatus,
  'reservation-statuses': statuses.reservationStatus,
  'reservation-cost-statuses': statuses.reservationCostStatus,
  'guide-cost-statuses': statuses.guideCostStatus,
  'activity-extras': activityExtra,
  'activity-categories': enumItems.activityCategory,
  'booking-statuses': statuses.booking,
  'bus-statuses': statuses.bus,
  'stripper-statuses': statuses.stripper,
  'stripper-roles': enumItems.stripperRole,
  'group-statuses': statuses.group,
  'guide-statuses': statuses.guide,
  'guide-wages': guideWage,
  'guide-costs': guideCost,
  'service-providers': serviceProvider,
  'bus-providers': enumItems.busProvider,
  guides: guide,
  drivers: driver,
  'booking-agents': enumItemsWithSalesPartner.bookingAgent,
  addresses: address,
  'address-types': enumItems.addressType,
  vehicles: enumItems.vehicle,
  'group-types': enumItems.groupType,
  countries: enumItems.country,
  languages: enumItems.language,
  'sales-partners': salesPartner,
  flights: enumItems.flight,
  bars: enumItems.bar,
  clubs: enumItems.club,
  restaurants: restaurant,
  'strip-bars': enumItems.stripBar,
  accommodations: accommodation,
  'accommodation-types': accommodationType,
  'accommodation-prices': accommodationPrice,
  rates: rate,
  contacts: contact,
  'bank-accounts': bankAccount,
  colors: color,
  'paid-by': enumItems.paidBy,
  'payment-dues': enumItems.paymentDue,
  'legal-entities': enumItems.legalEntity,
  'service-provider-types': enumItems.serviceProviderType,
  'payment-methods': enumItems.paymentMethod,
  'room-types': roomType,
  'language-levels': enumItems.languageLevel,
  'language-skills': languageSkills,
  'activity-reservation-costs': activityReservationCost,
  'activity-reservations': activityReservation(),
  'single-stripper-reservations': singleStripperReservation,
  'stripper-reservation-statuses': statuses.stripperReservationStatus,
  'room-reservations': roomReservation,
  'accommodation-reservations': accommodationReservation(),
  groups: group,
  currencies: enumItems.currency,
  'partner-daytimes': enumItems.partnerDaytime,
  'booked-bies': enumItemsWithColor.bookedBy,
  services: service,
  'service-types': enumItems.serviceType,
  'service-prices': servicePrice,
  comments: comment,
  'activity-types': enumItems.activityType,
  'partner-names': partnerName,
  'service-reservations': serviceReservation,
  competitors: competitor,
  'competitor-prices': competitorPrice,
  promotions: promotions,
  'service-se-statuses': statuses.serviceSeStatus,
  'service-sp-statuses': statuses.serviceSpStatus,
  'user-types': enumItems.userType,
  corporate: corporate,
  'corporate-payments': corporatePayment,
  'service-reservation-statuses': statuses.serviceReservationStatus,
  'accommodation-categories': accommodationCategory,
};

const getRequiredColumns = (columns: any, required: any) => {
  if (!required) {
    required = [];
  }

  const newColumns: any = {};
  Object.keys(columns).map((column: any) => {
    if (required.includes(column)) {
    }
    newColumns[`${column}`] = {
      ...columns[`${column}`],
      ['required']: required.includes(column),
    };
  });
  return newColumns;
};

export const DataPage: React.ComponentType = () => {
  const { table, id } = useParams();
  const schema = table ? PATH_TO_SCHEMA[table] : undefined;

  const [fullWidth, setFullWidth] = useState(!!id);
  const [width, setWidth] = useState(40);
  const [dragged, setDragged] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [searchParams, setSearchParams] = useState(new URLSearchParams());
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({
    schema: schema,
    row: {},
  });
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: schema,
    row: {},
  });
  const [selectedRow, setSelectedRow] = useState<any>(undefined);

  const openSlidingPaneHandle = (
    row: any,
    schema: any,
    newEntity?: boolean,
    openInFull?: boolean
  ) => {
    setOpenedSlidingPaneAddNew({
      schema: schema,
      row: {},
    });

    if (newEntity) {
      setOpenedSlidingPaneAddNew({
        schema: schema,
        row: row === undefined ? {} : row,
      });
    } else {
      setOpenedSlidingPane({
        schema: schema,
        row: row === undefined ? {} : row,
      });

      handlePanelWidth(!!openInFull);
    }
  };

  useEffect(() => {
    document.title = `Zoe DB-${schema?.pluralName}`;
  }, [schema]);

  const mainFunctionRef: any = useRef(null);

  const handleRefreshTableData = () => {
    mainFunctionRef.current();
  };
  const [lastForceFetchedStamp, setLastForceFetchedStamp] = useState<
    number | undefined
  >(undefined);
  const panelRef: any = useRef(null);

  const handlePanelWidth = (fullWidth: boolean) => {
    setFullWidth(fullWidth);
    if (panelRef.current) {
      panelRef.current.resize(fullWidth ? 100 : width);
    }
  };

  const savePanel = useCallback(() => {
    if (panelRef.current) {
      const size = panelRef.current?.getSize();
      setWidth(size);
    }
  }, [fullWidth]);

  useEffect(() => {
    if (id) {
      setFullWidth(true);
      schema.client.readOne(id, searchParams).then((res: any) => {
        setOpenedSlidingPane({
          schema: schema,
          row: res,
        });
      });
    }
  }, [id]);

  useEffect(() => {
    if (!dragged) {
      savePanel();
    }
  }, [dragged]);

  useEffect(() => {}, [schema]);

  const handleSelectedRowChange = (value: any) => {
    setSelectedRow(value);
  };
  const debouncedOnChange = debounce(handleSelectedRowChange, 300);

  const columnMask = useMemo(() => {
    return Object.keys(schema.columns).reduce((acc: any, key: any) => {
      return {
        ...acc,
        [key]: true,
      };
    }, {});
  }, []);

  const handleKickEvent = (data: any) => {};

  return schema ? (
    <>
      <SocketProvider schema={schema} onKick={handleKickEvent}>
        <PanelGroup direction="horizontal">
          <Panel>
            <PanelGroup direction="vertical">
              <Panel
                className={`${selectedRow ? '' : 'full-height'} ${
                  styles.Panel
                }`}
                collapsible={true}
                defaultSize={100}
                order={1}
              >
                <NewTable
                  setFunctionRef={(ref: any) => (mainFunctionRef.current = ref)}
                  searchParams={searchParams}
                  columnMask={columnMask}
                  schema={schema}
                  onRowSelected={(row: any) => {
                    setSelectedRow(row);
                  }}
                  isView={false}
                  selectedRowId={selectedRow}
                  setCurrentEditedRow={(row: any, openInFull?: boolean) => {
                    console.log('openSlidingPaneHandle 1 ---');
                    openSlidingPaneHandle(row, schema, false, openInFull);
                  }}
                  setCurrentAddNewRow={(row: any) => {
                    console.log('openSlidingPaneHandle 2 ---');

                    openSlidingPaneHandle(row, schema, true);
                  }}
                  hasSlidingPane={true}
                  lastForceFetchedStamp={lastForceFetchedStamp}
                />
              </Panel>
            </PanelGroup>
          </Panel>

          {openedSlidingPane?.row?.id && (
            <>
              <PanelResizeHandle
                className={`${styles.ResizeHandleOuter} bg-[#ddd]`}
                onDragging={(isDragged) => {
                  setDragged(isDragged);
                }}
                hitAreaMargins={{
                  coarse: 1,
                  fine: 1,
                }}
              >
                <div className={styles.ResizeHandleInner}>
                  <svg className={styles.Icon} viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z"
                    />
                  </svg>
                </div>
              </PanelResizeHandle>

              <Panel
                className={`${styles.Panel}`}
                collapsible={false}
                defaultSize={id || fullWidth ? 100 : 40}
                minSize={20}
                ref={panelRef}
              >
                <SlidingPane
                  setFullWidthProp={(value) => {
                    console.log('setFullWidthProp');
                    handlePanelWidth(value);
                  }}
                  schema={openedSlidingPane?.schema}
                  id={openedSlidingPane?.row?.id}
                  onSubmit={() => {
                    handleRefreshTableData();
                    setDisabled(false);
                    setOpenedSlidingPane({
                      schema: schema,
                      row: {},
                    });
                  }}
                  propertiesFromTable={
                    openedSlidingPane?.row ? openedSlidingPane?.row : {}
                  }
                  onClose={(value) => {
                    handleRefreshTableData();
                    setDisabled(false);
                    setOpenedSlidingPane({
                      schema: schema,
                      row: {},
                    });
                  }}
                  fullWidth={fullWidth}
                  addNewRow={(schema: any, tab: any) => {}}
                />
              </Panel>
            </>
          )}
        </PanelGroup>
      </SocketProvider>
      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={
              openedSlidingPaneAddNew?.hasOwnPane
                ? undefined
                : openedSlidingPaneAddNew?.row?.id
            }
            onSubmit={(value) => {
              handleRefreshTableData();
              setOpenedSlidingPaneAddNew({
                schema: schema,
                row: {},
              });
            }}
            propertiesFromTable={
              openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
            }
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({
                schema: schema,
                row: {},
              });
            }}
          />
        </>
      )}
    </>
  ) : null;
};
